import { Component, HostBinding, Input } from '@angular/core';
import { Association, AssociationKeys } from '@ag-common-lib/lib/models/utils/association.model';
import { AgentKeys, LayoutGridType, Messages } from '@ag-common-lib/public-api';

@Component({
  selector: 'ag-association-fun-stuff-sizes-form',
  templateUrl: './association-fun-stuff-sizes-form.component.html',
  styleUrl: './association-fun-stuff-sizes-form.component.scss'
})
export class AssociationFunStuffSizesFormComponent  {
  @HostBinding('class') className = 'fun-stuff-sizes-form';
  @Input() associationFormData: Association;
  @Input() validationGroup: string;
  @Input() type: LayoutGridType = LayoutGridType.short;

  protected readonly AssociationKeys = AssociationKeys;
  readonly Messages = Messages;
  protected readonly LayoutGridType = LayoutGridType;
  protected readonly AgentKeys = AgentKeys;
}
